import React from 'react'
import { BarChart } from '~/icons/simulator/BarChart'
import {
  vehicleIcons,
  ignoredVehiclesInTable,
} from '~/components/slices/simulatorFuel/SimulatorStatic'
import { Tabs } from '~/components/features/tabs/tabs'

const renderTableHeaders = ({ section1Block3Tables, columns }) => {
  return columns.map((column) => {
    const title = section1Block3Tables[column]?.title ?? ''
    const subtitle = section1Block3Tables[column]?.subtitle ?? ''
    const hasLotOfText = title.length + subtitle.length > 82
    return (
      <th
        key={column}
        className={`bg-purple text-white px-5 py-3 border-b border-gray-200 text-left text-sm font-normal other-col ${
          hasLotOfText ? 'wider-col' : ''
        }`}
      >
        <div className="text-16 font-semibold">
          {section1Block3Tables[column].title}
        </div>
        {section1Block3Tables[column].subtitle && (
          <div>{`(${section1Block3Tables[column].subtitle})`}</div>
        )}
      </th>
    )
  })
}

const renderTableRows = ({ section1Block3Tables, fuelTypeData, columns }) =>
  columns.map((column) => (
    <td
      key={column}
      className="px-5 py-5 border-b border-gray-200 bg-white text-sm"
    >
      {section1Block3Tables[column].type === 'bar' && (
        <BarChart
          barCount={fuelTypeData[column].barCount}
          color={fuelTypeData[column].color}
          className="mx-auto"
        />
      )}
      {section1Block3Tables[column].type === 'categories' && (
        <div className="flex gap-4 categories">
          {Object.keys(vehicleIcons)
            .filter((icon) => !ignoredVehiclesInTable.includes(icon))
            .map((icon, categoryIndex) => {
              const isPresent = fuelTypeData.modeTransport.includes(icon)
              const iconOpacityClass = isPresent ? '' : 'icon-less-opacity'
              return (
                <>
                  <div
                    key={icon}
                    className={`flex items-center relative ${iconOpacityClass}`}
                  >
                    {React.cloneElement(vehicleIcons[icon], { key: icon })}
                    {categoryIndex !== 0 && (
                      <hr className="categories-divider" />
                    )}
                  </div>
                </>
              )
            })}
        </div>
      )}
    </td>
  ))

export const SimulatorFuelMoreTables = ({ contentfulData }) => {
  const {
    section1Block3Tables,
    section3TablesOrganization,
    fuelDataGlobalConfiguration,
  } = contentfulData
  // const section1Block3Tables = JSON.parse(
  //   section1Block3TablesObject?.internal?.content
  // )
  // const section3TablesOrganization =
  //   section3TablesOrganizationObject?.internal &&
  //   JSON.parse(section3TablesOrganizationObject?.internal?.content)

  const tabsData = section3TablesOrganization?.map((table) => ({
    id: table.id,
    name: table.title,
    content: (
      <div className="mb-5">
        <div className="table-wrapper">
          <table className="leading-normal table-normal">
            <thead>
              <tr>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <th className="first-col px-5 py-3 border-b-2 border-gray-200 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"></th>
                {renderTableHeaders({
                  section1Block3Tables: section1Block3Tables,
                  columns: table.columns,
                })}
              </tr>
            </thead>
            <tbody>
              {Object.entries(fuelDataGlobalConfiguration).map(
                ([fuelType, fuelTypeData]) => (
                  <tr
                    key={fuelType}
                    className={
                      fuelTypeData.generalColor === 'green'
                        ? 'row-bg-light-green'
                        : ''
                    }
                  >
                    <td className="text-15 font-semibold first-col px-5 py-5 border-b border-gray-200 bg-white">
                      {fuelTypeData.lib}
                    </td>
                    {renderTableRows({
                      section1Block3Tables: section1Block3Tables,
                      fuelTypeData,
                      columns: table.columns,
                    })}
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      </div>
    ),
  }))

  return <div>{tabsData && <Tabs tabs={tabsData} />}</div>
}
